import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InvoiceItem } from '../invoice.item';

@Component({
    selector: 'app-select-offer-dialog',
    templateUrl: './select-offer-dialog.component.html',
    styleUrls: ['./select-offer-dialog.component.css']
})
export class SelectOfferDialogComponent implements OnInit {

    @Input() offers: any = {
        offerList: []
    };

    @Input() invoiceItems: InvoiceItem[];

    @Output() onContinueFromOffers = new EventEmitter<number>();
    @Output() onBackFromOffers = new EventEmitter<number>();
    @Output() onContinueFromSummary = new EventEmitter<number>();
    @Output() onBackFromSummary = new EventEmitter<number>();
    @Output() onContinueFromAmendment = new EventEmitter<number>();
    @Output() onBackFromAmendment = new EventEmitter<number>();

    @Input() selectedOfferRadio: FormControl;

    constructor() { }

    ngOnInit() {
    }

    onContinueFromOffersClick() {
        this.onContinueFromOffers.emit(Number(this.selectedOfferRadio.value));
    }

    get selectedOffer () {
        let selectedOffer = {useMaxApprovedAmount: false, payment: 0, term: 0};
        this.offers.offerList.forEach((offer: any) => {
            if (offer.offerId == Number(this.selectedOfferRadio.value)) {
                selectedOffer = offer;
            }
        });
        return selectedOffer;
    }

    get invoiceDueToday () {
        if (this.selectedOffer !== null) {
            if (this.selectedOffer.useMaxApprovedAmount) {
                if ((this.invoiceTotal - this.offers.maxApproved) < 0) {
                    return 0;
                } else {
                    return this.invoiceTotal - this.offers.maxApproved;
                }
            } else {
                if ((this.invoiceTotal - this.offers.requestAmount) < 0) {
                    return 0;
                } else {
                    return this.invoiceTotal - this.offers.requestAmount;
                }
            }
        }
    };

    get invoiceTotal () {
        let invoiceTotal = 0;
        this.invoiceItems.forEach(element => {
            invoiceTotal += Number(element.iForm.equipmentCost.value);
        });
        return invoiceTotal;
    }

    onBackFromOffersClick() {
        this.onBackFromOffers.emit(Number(this.selectedOfferRadio.value));
    }

    onContinueFromSummaryClick() {
        this.onContinueFromSummary.emit(Number(this.selectedOfferRadio.value));
    }

    onBackFromSummaryClick() {
        this.onBackFromSummary.emit(Number(this.selectedOfferRadio.value));
    }

    onContinueFromAmendmentClick() {
        this.onContinueFromAmendment.emit(Number(this.selectedOfferRadio.value));
    }

    onBackFromAmendmentClick() {
        this.onBackFromAmendment.emit(Number(this.selectedOfferRadio.value));
    }
}
